/**
 * 签约状态
 */
export const enum CONTINUOUS_STATUS {
    /** 未签约 */
    UNSIGNED = 1,
    /** 已签约 */
    SIGNED = 2
}